import React, { useState } from 'react';
import { Search, X } from 'lucide-react';

function SearchBar({ searchQuery, onSearch, onClear }) {
  const [inputValue, setInputValue] = useState(searchQuery);

  function handleSubmit(e) {
    e.preventDefault();
    onSearch(inputValue.trim());
  }

  function handleClear() {
    setInputValue('');
    onClear();
  }

  function handleChange(e) {
    setInputValue(e.target.value);
  }

  return (
    <form onSubmit={handleSubmit} className="relative">
      <div className="relative">
        <input
          type="text"
          value={inputValue}
          onChange={handleChange}
          placeholder="Buscar productos por nombre, descripción o SKU..."
          className="w-full pl-11 pr-24 py-3 border-2 border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-primary/20 focus:border-brand-primary transition-all font-montserrat text-sm"
        />
        
        <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />

        <div className="absolute right-2 top-1/2 -translate-y-1/2 flex gap-1">
          {inputValue && (
            <button
              type="button"
              onClick={handleClear}
              className="p-1.5 hover:bg-slate-100 rounded-md transition-colors"
              aria-label="Limpiar búsqueda"
            >
              <X className="w-4 h-4 text-slate-500" />
            </button>
          )}

          <button
            type="submit"
            className="px-3 py-1.5 bg-brand-primary hover:bg-brand-primary/90 text-white rounded-md transition-all font-montserrat text-sm font-semibold"
          >
            Buscar
          </button>
        </div>
      </div>
    </form>
  );
}

export default SearchBar;